@if ($imageInputs().length > 0) {
    <cm-inspector-section>
        <ng-container cm-title>Drawn overlays</ng-container>
        <ng-container cm-content>
            @for (imageInput of $imageInputs(); track imageInput.key) {
                <cm-button (click)="draw(imageInput.key, imageInput.label)">
                    <ng-container cm-text> Draw: {{ imageInput.label }} </ng-container>
                </cm-button>
            }
        </ng-container>
    </cm-inspector-section>
}
